<template>
  <div>

    <b-row>
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Role" :required="true">
              <input
                ref="name"
                type="text"
                @blur="$v.role.role.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.role.role.$error }"
                v-model="role.role"
              />
              <div class="invalid-feedback" v-if="!$v.role.role.required">
                Pcontract enter role
              </div>
            </form-group>

            <form-group label="Permissions" :required="true">
              <span v-for="item in permissions" :key="item.id">
              <b-form-checkbox
                v-model="role.permissions"
                :value="item.id"
              >
               {{ item.permission }}
              </b-form-checkbox>
              </span>
                <div class="text-danger" v-if="$v.role.permissions.$error">
                Pcontract select permissions
              </div>
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import roleRepo from '@/api/repos/roleRepo'
import permissionRepo from '@/api/repos/permissionRepo'
import { required } from 'vuelidate/lib/validators'
import formBase from '@/components/common/FormBase'
import formGroup from '@/components/common/FormGroup'

export default {
  components: {
    formBase,
    formGroup
  },

  validations: {
    role: {
      role: {
        required
      },
      permissions: {
        required
      }
    }

  },

  data () {
    return {
      role: {
        role: '',
        permissions: []
      },
      permissions: [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false
    }
  },

  mounted () {
    this.$refs.name.focus()
    this.getPermissions()
  },

  methods: {
    async getPermissions () {
      let { data } = await permissionRepo.permissions()
      this.permissions = data.permissions
    },
    async handleSubmit () {
      this.loading = true
      this.submitStatus = 'PENDING'
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
        this.loading = false
      } else {
        try {
          await roleRepo.create(this.role)
          this.$emit("roleCreated");
        } catch (error) {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
            console.log(this.errors)
               this.$root.$bvToast.toast('Form Errors', {
                title: 'Errors on form data',
                autoHideDelay: 3000,
                variant: 'danger',
            })
          }
        } finally {
          this.loading = false
          this.submitStatus = null
        }
      }
    }
  }
}
</script>

<style></style>
